module.exports = __webpack_public_path__ + "img/kenza.54ccba9f.png";